module.exports = __webpack_public_path__ + "static/media/image_67.6b3b1873.png";